import LoginIcon from "@mui/icons-material/Login";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import type { SsoProvider } from "@/features/auth/model/tenant-discovery";

interface SsoButtonsProps {
  providers: readonly SsoProvider[];
  disabled: boolean;
  loadingProviderId: string | null;
  onSsoSignIn: (providerId: string) => void;
}

function getProviderIcon(provider: SsoProvider) {
  const providerKind = provider.provider_kind.toLowerCase();

  if (providerKind.includes("microsoft") || providerKind.includes("entra")) {
    return <ShieldOutlinedIcon color="primary" sx={{ fontSize: 16 }} />;
  }

  return <LoginIcon color="primary" sx={{ fontSize: 16 }} />;
}

export function SsoButtons({
  providers,
  disabled,
  loadingProviderId,
  onSsoSignIn,
}: SsoButtonsProps) {
  if (providers.length === 0) {
    return null;
  }

  return (
    <Stack spacing={1.25}>
      {providers.map((provider) => (
        <Button
          key={provider.provider_id}
          type="button"
          variant="outlined"
          startIcon={getProviderIcon(provider)}
          onClick={() => onSsoSignIn(provider.provider_id)}
          disabled={disabled}
          fullWidth
        >
          {loadingProviderId === provider.provider_id ? "Redirecting..." : provider.button_text}
        </Button>
      ))}
    </Stack>
  );
}
